<template>
  <div class="planDetailPage">
    <StickyTop />
    <Banner zoomWay="click" :slideList="slideList" :dblclickImage="dblclickImage" />
    <div class="planInfoList">
      <h3 class="planName">{{ detailData?.productName }}</h3>
      <p v-if="detailData.ctag" class="planTag" style="margin-bottom:5px;">{{ detailData?.ctag }}</p>
      <span class="moneyWeight">{{ shopPrice }}</span>
    </div>
    <div class="dealerInfoList">
      <van-row class="label">
        <van-col span="8">车辆：</van-col>
        <van-col span="16">{{ carInfoTxts }}</van-col>
      </van-row>
      <van-row class="label" v-show="salesAttributesTxt !== false">
        <van-col span="8">选择：</van-col>
        <van-col span="16" @click="selectSalesAttributes"
          ><span class="fvlr salesAttribute">
            <span>{{ salesAttributesTxt }}</span>
            <van-icon name="arrow" /> </span
        ></van-col>
      </van-row>
      <CurrentDealer @setLoading="setLoading" from="ewShopDetail" :isOtrOrderNo="isOtrOrderNo" :colLabelSpan="8">
        <template #colLabel><span>销售经销商：</span></template>
        <template #noDealer>请选择经销商查看商品详情及价格</template>
      </CurrentDealer>
      <UseDealer ref="useDealerRef" @setLoading="setLoading" :isShowPhone="true" :colLabelSpan="8" :param="applyDealerParam" @useclick="handleUseclick">
        <template #colLabel><span>使用/服务范围:</span></template>
        <template #currentDealerBox>
          <span v-if="hasDealer" class="accordionContent underline themeColor">点击查看</span>
          <span v-else class="useDealerRmark">请选择商品及购买经销商后查看</span>
        </template>
        <template #afterName><span></span></template>
      </UseDealer>
    </div>
    <SkuImg :datas="skuAloneData" />
    <!-- 底部按钮栏目 -->
    <GoodsBar :isEnterShoppingCar="isEnterShoppingCar && !isOtrOrderNo" :isEnable="isEnable" from="shopDetail" @clickGoodBtn="clickGoodBtn">
      <ConfirmShop
        ref="confirmShopRef"
        @clickSureBtn="clickSureBtn"
        :datas="{ shopInfoDatas, carInfoTxt, useCarInfo, sign: 'ewProduct' }"
        :showTyreNum="showShopNum"
        :from="confirmTyreFrom"
        :type="confirmTyreType"
      />
    </GoodsBar>
    <div v-show="isShowLoad" class="loadBox">
      <van-loading size="30px" vertical color="#fff"><span style="color:#fff">加载中...</span> </van-loading>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { reactive, toRefs, onMounted, watch, onUnmounted, computed, ref, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

import { getEWShopDealerListBySpu } from '@/api/directSales'
import { addEWShoppingCar } from '@/api/shoppingCar'
import UseDealer from '@/components/canUseDealer/CurrentDealer'
import Banner from '@/components/common/Banner'
import GoodsBar from '@/components/common/GoodsBar'
import CurrentDealer from '@/components/dealer/CurrentDealer'
import ConfirmShop from '@/components/shop/ConfirmShop'
import StickyTop from '@/components/shop/StickyTop.vue'
import SkuImg from '@/components/shop/SkuImg.vue'
import useCurrentCarInfo from '@/hooks/directSales/useCurrentCarInfo'
import useShopDetail from '@/hooks/directSales/useEWShopDetail'
import { backTop, getDistance } from '@/util'
import { showToast } from '@/util/couponCollection'

export default {
  name: 'ewShopDetail',
  components: {
    Banner,
    CurrentDealer,
    UseDealer,
    GoodsBar,
    ConfirmShop,
    StickyTop,
    SkuImg
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const useDealerRef = ref()
    const confirmShopRef = ref()
    const { carInfoTxt, carInfo: useCarInfo } = useCurrentCarInfo()
    const {
      getShopDetailFn,
      salesAttributesTxt,
      slideList,
      dblclickImage,
      detailData,
      isEnterShoppingCar,
      isEnable,
      hasDealer,
      shopInfoDatas,
      applyDealerParam,
      shopPrice
    } = useShopDetail()
    const { spuId, from, gsCode, orderNo, skuId, fin } = route.query
    store.commit('SETSkUITEM', {})
    store.commit('SETSTEPPEROPTION', {})
    const state = reactive({
      carInfoTxts: '',
      isOtrOrderNo: orderNo,
      gsCode: gsCode,
      confirmTyreFrom: '', //详情页/购物车/属性选择
      confirmTyreType: '', //立即购买/加入购物车
      showShopNum: 0,
      isShowLoad: false
    })

    // 设置gsCode，防止加载默认经销商
    gsCode && store.dispatch('setDealerInfo', { gs_code: gsCode, gsCode })
    const initByfrom = async data => {
      const _gsCode = data.gsCode || gsCode
      const isFreeze = from === 'scan' && _gsCode
      store.commit('SETEWSCANFROMOTR', from === 'scan' && orderNo)
      store.commit('SETDEALERfREEZEFLAG', isFreeze)
      if (isFreeze) {
        await getDealerFn({ gsCode: _gsCode })
      }
    }
    const handleUseclick = () => {
      if (!applyDealerParam || !applyDealerParam?.value?.skuId || !applyDealerParam?.value?.gsCode) {
        showToast('请先选择销售经销商和商品')
        return
      }
      useDealerRef.value.showPop()
    }
    const getDealerFn = async (data = {}) => {
      try {
        const { lat, lng } = store.state.position
        const list = await getEWShopDealerListBySpu(spuId, {
          gsCode: data?.gsCode || '',
          latitude: lat,
          longitude: lng
        })
        const dealerInfo = list[0] || {}
        dealerInfo.distance = getDistance(dealerInfo.distance, true)
        const _gsCode = dealerInfo.gs_code || dealerInfo.gsCode || state.gsCode
        dealerInfo.gs_code = dealerInfo.gsCode = _gsCode
        store.dispatch('setLoyaltyDealerInfo', dealerInfo)
      } catch (e) {
        showToast(e.message, '获取经销商详情失败')
        store.dispatch('setLoyaltyDealerInfo', {})
      }
    }
    onUnmounted(() => {
      store.commit('SETEWSCANFROMOTR', false)
      store.commit('SETDEALERfREEZEFLAG', false)
      store.commit('SETSPUID', '')
      if (!useCarInfo.value?.id) {
        store.dispatch('setCurrentCarInfo', {})
      }
    })
    const setLoading = data => {
      state.isShowLoad = data
    }

    const toShoppingCar = () => {
      router.push({ path: '/shoppingCar', query: { event: '查看购物车' } })
    }
    const clickSureBtn = data => {
      if (data.from === 'shopDetail' && (data.type == 'bugNow' || data.type == 'addShoppingCar')) {
        const loyaltyDealerInfo = store.state.loyaltyDealerInfo || {}
        const gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
        const selectedSkuItem = store.state?.skuItem || {}
        if (!gsCode) {
          showToast('请选择经销商')
          return
        }
        if (!selectedSkuItem.skuId) {
          showToast('请选择商品')
          return
        }
        if (selectedSkuItem.maxPurchaseMile !== -1) {
          Dialog.confirm({
            title: '提示',
            message: `请确保爱车的实际里程不超出该产品最大使用里程数（${selectedSkuItem.maxPurchaseMile} 公里）`,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            confirmProduct(data.type, gsCode, selectedSkuItem)
          })
        } else {
          confirmProduct(data.type, gsCode, selectedSkuItem)
        }
      }
    }

    const confirmProduct = async (type, gsCode, selectedSkuItem) => {
      if (type === 'bugNow') {
        const currentBuyProductInfo = {
          shopData: {
            product: {
              carInfo: useCarInfo?._object?.carInfo,
              gsCode,
              productId: selectedSkuItem.skuId
            },
            orderNo: state.isOtrOrderNo
          }
        }
        store.dispatch('setCurrentBuyProductInfo', currentBuyProductInfo)
        router.push({
          path: '/confirmDirectSalesOrder',
          query: { from: 'ewShopDetail', event: '商城商品下单' }
        })
      } else if (type === 'addShoppingCar') {
        const params = {
          customerCarId: useCarInfo.value?.id, //车辆编号
          gsCode, //经销商code
          productSkuId: selectedSkuItem.skuId, //商品编号
          quantity: store.state.stepperOption?.value, //购买商品数量
          productType: 'EW' //购买商品类型{1:计划2:轮胎,3:服务合约}
        }
        try {
          await addEWShoppingCar(params)
          showToast('加入购物车成功')
          confirmShopRef.value?.closePop()
          store.dispatch('getCountOfShoppingCar')
        } catch (e) {
          showToast(e.message, '加入购物车失败')
        }
      }
    }

    const selectSalesAttributes = () => {
      clickGoodBtn({ type: 'selectAttribut', from: 'shopDetail' })
    }
    const clickGoodBtn = data => {
      const { loyaltyDealerInfo } = store.state
      const gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
      if (!gsCode) {
        showToast('请先选择一个销售经销商')
        return
      }
      if (['selectAttribut', 'bugNow', 'addShoppingCar'].includes(data.type)) {
        state.confirmTyreFrom = data.from
        state.confirmTyreType = data.type
        nextTick(() => {
          state.showShopNum += 1
        })
      }
      if (data.type == 'toShoppingCar') {
        router.push({ path: '/shoppingCar', query: { event: '查看购物车' } })
      }
    }

    watch(
      () => store.state.position,
      async position => {
        console.log('shopDetail-watch-', position)
        position &&
          position?.lat &&
          setTimeout(() => {
            const { loyaltyDealerInfo: dealerInfo } = store.state
            const dealerGsCode = dealerInfo?.gs_code || dealerInfo?.gsCode
            const _gsCode = gsCode || dealerGsCode
            if (_gsCode) {
              if (!dealerInfo.distance) {
                //有gscode and 没有距离 => 刷新距离
                getDealerFn({ gsCode: _gsCode })
              }
            } else {
              // 没有经销商 and 有经纬度 => 尝试再次获取距离最近的经销商
              getDealerFn()
            }
          }, 500)
      },
      { deep: true }
    )
    const skuAloneData = computed(() => {
      const skuItem = store.state.skuItem || {}
      const detailPics = detailData.value?.detailPics || []
      const skuPics = (skuItem.detailPics?.length && skuItem.detailPics) || detailPics
      return { ...skuItem, skuPics }
    })

    onMounted(async () => {
      const { loyaltyDealerInfo } = store.state
      const _gsCode = orderNo ? state.gsCode : loyaltyDealerInfo?.gsCode || loyaltyDealerInfo?.gs_code
      await initByfrom({ gsCode: _gsCode })
      await getShopDetailFn({ spuId, orderNo: state.isOtrOrderNo, fin: orderNo ? fin : useCarInfo.value?.fin, gsCode: _gsCode, skuId })
      nextTick(() => {
        if (state.isOtrOrderNo && shopInfoDatas?.value?.carInfo) {
          store.dispatch('setCurrentCarInfo', shopInfoDatas?.value?.carInfo)
          const currentCarInfo = shopInfoDatas?.value?.carInfo
          const plate = currentCarInfo && currentCarInfo.plate ? currentCarInfo.plate : ''
          const model = currentCarInfo && currentCarInfo.model ? currentCarInfo.model.replace(/\(.*?\)/g, '') : ''
          state.carInfoTxts = model ? `${plate || '暂无车牌'} | ${model}` : ''
          console.log('shopDetail-onMounted--state.carInfoTxts', state.carInfoTxts)
        } else {
          state.carInfoTxts = carInfoTxt
        }
      })
      backTop()
    })
    return {
      ...toRefs(state),
      skuAloneData,
      salesAttributesTxt,
      shopInfoDatas,
      getShopDetailFn,
      toShoppingCar,
      setLoading,
      handleUseclick,
      carInfoTxt,
      useCarInfo,
      clickGoodBtn,
      slideList,
      dblclickImage,
      detailData,
      isEnterShoppingCar,
      isEnable,
      hasDealer,
      applyDealerParam,
      selectSalesAttributes,
      useDealerRef,
      confirmShopRef,
      clickSureBtn,
      shopPrice
    }
  }
}
</script>

<style lang="scss" scoped>
.planDetailPage {
  background-color: #f5f5f5;
  text-align: left;
  padding-bottom: calc(100px + constant(safe-area-inset-bottom));
  padding-bottom: calc(100px + env(safe-area-inset-bottom));

  .planInfoList {
    padding: 12px 20px;
    background-color: #fff;
    margin-bottom: 8px;
  }
  .dealerInfoList {
    padding: 18px 20px 10px;
    background-color: #fff;
  }
}
.planDetailPage::-webkit-scrollbar {
  display: none;
}
// 计划信息样式
.planInfoList {
  h3 {
    font-size: 18px;
    color: #333;
    font-weight: 700;
    margin-bottom: 12px;
  }

  .moneyWeight {
    font-size: 16px;
    color: #3088c5;
    font-weight: bold;
    line-height: 30px;
  }
}

// 经销商样式
.dealerInfoList {
  .label {
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    line-height: 18px;
  }
}

.useDealerRmark {
  color: #999;
  font-size: 14px;
}
.accordionContent {
  width: 100%;
  :deep(p) {
    word-break: break-all;
  }
}
.loadBox {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  padding-top: 250px;
  background-color: rgba($color: #000000, $alpha: 0.4);
}
.salesAttribute {
  border-bottom: 1px solid #ccc;
  font-style: oblique;
}
</style>
